/**
 * Public widget + MediKaLLink path catalog (committed `frontendapi.json` at repo root).
 * No secrets — safe for the browser bundle. Backend uses `backend/backendapi.json` only.
 */
import data from '../../frontendapi.json' with { type: 'json' }

export type FrontendApiConfig = typeof data

export const frontendApiConfig: FrontendApiConfig = data
